import React from "react";
import { useSelector } from "react-redux";
import GuessButton from "./GuessButton";
import "./NewsieBottomBar.css";

import Stopwatch from "./Stopwatch";
import IncorrectGuesses from "./IncorrectGuesses";
const NewsieBottomBar = () => {
  const incorrectGuesses = useSelector(
    (state) => state.publicPuzzleSlice.puzzle.incorrectGuesses
  );

  const time = useSelector((state) => state.publicPuzzleSlice.puzzle.timer);

  const guessable = useSelector(
    (state) => state.publicPuzzleSlice?.puzzle.guessable
  );
  const gameOver = useSelector(
    (state) => state.publicPuzzleSlice.puzzle.gameOver
  );

  const SCORE = 1000 - time - 10 * incorrectGuesses;

  return (
    <div className="game-details">
      <Stopwatch />
      <IncorrectGuesses incorrectGuesses={incorrectGuesses} />
      <GuessButton
        guessable={guessable}
        gameOver={gameOver}
        incorrectGuesses={incorrectGuesses}
        time={time}
        score={SCORE}
      />
    </div>
  );
};

export default NewsieBottomBar;
